/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ElectoralDistrictAssociationsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Information for Nova Scotia Electoral District Associations"
              description={
                <>
                  <p>In each electoral district, registered parties may establish Electoral District Associations (EDA). Each EDA must be registered with ENS, including an annual renewal. An EDA is endorsed by the leader of the registered party to further the goals of the registered party. </p>
                  <br />
                  <h3>The annual deadlines for filing these reports are:</h3>
                  <br />
                  <p>Registration Renewal of EDA: March 31</p><br />
                  <p>Change in information: 10 days after effective date of change</p>
                  <br />
                  <p>Annual Financial Report: March 31</p>
                  <br />
                  <p>Fundraising: 120 days after event (these are normally processed through the Party, since tax receipts are allowed to be issued only by the party or the candidate)</p>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><p><a href="/files/ElectoralDistrictAssociations/EDAStatus2021August03.pdf">Status of Electoral District Associations, August 3, 2023</a></p></li>
                    <li><p><a href="/files/ElectoralDistrictAssociations/EDAStatus2021June24.pdf">Status of Electoral District Associations, June 24, 2021</a></p></li>
                    <li><p><a href="/files/ElectoralDistrictAssociations/EDAStatus2021January14.pdf">Status of Electoral District Associations, January 14, 2021</a></p></li>
                    <li><p><a href="/files/ElectoralDistrictAssociations/EDAStatus2020November2.pdf">Status of Electoral District Associations, November 2, 2020</a></p></li>
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ElectoralDistrictAssociationsInformation;
